import { createContext, useContext, useEffect, useState } from 'react';
import api from '../lib/api';
import { getToken, setToken, clearToken } from '../lib/token';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!getToken()) {
      setLoading(false);
      return;
    }
    api
      .get('/auth/me')
      .then((r) => setUser(r.data))
      .catch(() => clearToken())
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    let lastErr;
    for (let attempt = 0; attempt < 3; attempt++) {
      try {
        const { data } = await api.post('/auth/login', { email, password });
        setToken(data.token);
        setUser(data.user);
        return;
      } catch (err) {
        lastErr = err;
        if (err.response) throw err; // 401/429 dll: jangan retry
        await new Promise((r) => setTimeout(r, 2000)); // network error (server cold-start): retry
      }
    }
    throw lastErr;
  };

  const logout = () => {
    clearToken();
    setUser(null);
    window.location.href = '/login';
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
